import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f985680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container" }
const _hoisted_2 = { class: "orangehrm-paper-container finance-dashboard" }
const _hoisted_3 = { class: "finance-dashboard__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Finance"),
  /*#__PURE__*/_createElementVNode("p", null, "Company expenses and payroll overview")
], -1))
const _hoisted_5 = { class: "finance-dashboard__controls" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "finance-dashboard__cards" }
const _hoisted_9 = { class: "finance-card__label" }
const _hoisted_10 = { class: "finance-card__value" }
const _hoisted_11 = { class: "finance-card__hint" }
const _hoisted_12 = {
  key: 0,
  class: "finance-charts"
}
const _hoisted_13 = { class: "finance-panel chart-panel" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Monthly expenses vs payroll", -1))
const _hoisted_15 = { class: "trend-chart" }
const _hoisted_16 = { class: "trend-bars" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-legend" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "expense-bar" }),
    /*#__PURE__*/_createTextVNode("Expenses")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "payroll-bar" }),
    /*#__PURE__*/_createTextVNode("Payroll")
  ])
], -1))
const _hoisted_20 = { class: "finance-panel chart-panel" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Expenses by category", -1))
const _hoisted_22 = {
  key: 0,
  class: "category-chart"
}
const _hoisted_23 = {
  key: 1,
  class: "finance-empty"
}
const _hoisted_24 = { class: "finance-panel chart-panel" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Payroll by department", -1))
const _hoisted_26 = {
  key: 0,
  class: "department-chart"
}
const _hoisted_27 = {
  key: 1,
  class: "finance-empty"
}
const _hoisted_28 = { class: "finance-panel" }
const _hoisted_29 = { class: "finance-panel__heading" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recent transactions", -1))
const _hoisted_31 = {
  key: 0,
  class: "finance-error"
}
const _hoisted_32 = {
  key: 0,
  class: "finance-empty"
}
const _hoisted_33 = {
  key: 1,
  class: "finance-empty"
}
const _hoisted_34 = {
  key: 2,
  class: "finance-table-wrap"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Reference"),
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
            "aria-label": "Month"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.value,
                value: item.value
              }, _toDisplayString(item.label), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [
              _vModelSelect,
              _ctx.month,
              void 0,
              { number: true }
            ]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.year) = $event)),
            "aria-label": "Year"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item,
                value: item
              }, _toDisplayString(item), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [
              _vModelSelect,
              _ctx.year,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("button", {
            class: "finance-button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadDashboard && _ctx.loadDashboard(...args)))
          }, "Apply")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
          return (_openBlock(), _createElementBlock("section", {
            key: card.title,
            class: "finance-card"
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(card.title), 1),
            _createElementVNode("strong", _hoisted_10, _toDisplayString(card.value), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(card.hint), 1)
          ]))
        }), 128))
      ]),
      (_ctx.snapshot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("section", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshot.monthlyTrend, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.month_start,
                    class: "trend-month"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("i", {
                        class: "expense-bar",
                        style: _normalizeStyle({height: _ctx.barHeight(item.expenses, _ctx.trendMaximum)}),
                        title: `Expenses ${_ctx.money(item.expenses)}`
                      }, null, 12, _hoisted_17),
                      _createElementVNode("i", {
                        class: "payroll-bar",
                        style: _normalizeStyle({height: _ctx.barHeight(item.payroll, _ctx.trendMaximum)}),
                        title: `Payroll ${_ctx.money(item.payroll)}`
                      }, null, 12, _hoisted_18)
                    ]),
                    _createElementVNode("small", null, _toDisplayString(_ctx.shortMonth(item.month_start)), 1)
                  ]))
                }), 128))
              ]),
              _hoisted_19
            ]),
            _createElementVNode("section", _hoisted_20, [
              _hoisted_21,
              (_ctx.snapshot.expenseByCategory?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "category-donut",
                      style: _normalizeStyle({background: _ctx.categoryGradient})
                    }, null, 4),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshot.expenseByCategory, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.label
                        }, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({background: _ctx.chartColors[index % _ctx.chartColors.length]})
                          }, null, 4),
                          _createTextVNode(_toDisplayString(item.label) + " ", 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.money(item.total)), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_23, " No approved expenses for this month. "))
            ]),
            _createElementVNode("section", _hoisted_24, [
              _hoisted_25,
              (_ctx.snapshot.payrollByDepartment?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshot.payrollByDepartment, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.label,
                        class: "department-row"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.label), 1),
                        _createElementVNode("i", null, [
                          _createElementVNode("b", {
                            style: _normalizeStyle({width: _ctx.barHeight(item.total, _ctx.departmentMaximum)})
                          }, null, 4)
                        ]),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.money(item.total)), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_27, " No approved payroll for this month. "))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", null, [
            _hoisted_30,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "finance-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openExpenses && _ctx.openExpenses(...args)))
          }, " Manage expenses ")
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Loading finance data…"))
          : (!_ctx.snapshot?.recentTransactions?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, " No company expenses have been recorded for this month. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("table", null, [
                  _hoisted_35,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshot.recentTransactions, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `${item.type}-${item.id}`
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.transaction_date), 1),
                        _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                        _createElementVNode("td", null, _toDisplayString(item.description), 1),
                        _createElementVNode("td", null, _toDisplayString(item.currency) + " " + _toDisplayString(_ctx.money(item.amount)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.statusLabel(item.status)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
      ])
    ])
  ]))
}